import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const Custom_URL = `${API_URL}/custom`;
const Product_URL = `${API_URL}/product`;
const Route_URL = `${API_URL}/route`;

const listBrand = () => {
  return axios.get(`${Custom_URL}/list-brand`).then((response) => {
    return response;
  });
};

const listFeature = () => {
  return axios.get(`${Custom_URL}/list-feature`).then((response) => {
    return response;
  });
};
const listSpeacification = () => {
  return axios.get(`${Custom_URL}/list-speacification`).then((response) => {
    return response;
  });
};
const listVariant = () => {
  return axios.get(`${Custom_URL}/list-variant`).then((response) => {
    return response;
  });
};
const listCategory = () => {
  return axios.get(`${Custom_URL}/list-category`).then((response) => {
    return response;
  });
};

const listProduct = () => {
  return axios.get(`${Product_URL}/list`).then((response) => {
    console.log("response listProduct api", response)
    return response;
  });
};

const createProduct = (formData: FormData) => {
  return axios.post(`${Product_URL}/add`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Set Content-Type header to multipart/form-data
    }
  })
    .then((response) => {
      return response.data || response;
    })
    .catch((error) => {
      return error.response?.data || { status: false, message: "An error occurred while creating the product" };
    });
};

const updateProduct = (formData: FormData, id: any) => {
  return axios.put(`${Product_URL}/edit/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Set Content-Type header to multipart/form-data
    }
  })
    .then((response) => {
      return response.data || response;
    })
    .catch((error) => {
      return error.response?.data || { status: false, message: "An error occurred while updating the product" };
    });
};

const viewProduct = (id: any) => {
  return axios.get(`${Product_URL}/view/${id}`).then((response) => {
    return response;
  });
};

const deleteProduct = (id: any) => {
  return axios.put(`${Product_URL}/delete/${id}`).then((response) => {
    return response;
  });
};

const listRoute = () => {
  return axios.get(`${Route_URL}/list`).then((response) => {
    return response;
  });
};




const Subscription_URL = `${API_URL}/subscription`;

const getProductPlanList = (productId: any) => {
  return axios.get(`${Subscription_URL}/product-plan-list/${productId}`).then((response) => {
    return response;
  });
};

const getProductUserSubscriptions = (productId: any, filter: string = "all") => {
  return axios.get(`${Subscription_URL}/product-user-subscriptions/${productId}?filter=${filter}`).then((response) => {
    return response;
  });
};

export {
  listBrand,
  listFeature,
  listSpeacification,
  listVariant,
  listCategory,
  listProduct,
  createProduct,
  updateProduct,
  viewProduct,
  deleteProduct,
  listRoute,
  getProductPlanList,
  getProductUserSubscriptions
};
